const state = {
  orderDataForResult: {}, // 存储订单数据
};

// getters
const getters = {
  orderDataForResult: (state) => state.orderDataForResult,
};

// actions
const actions = {
  setOrderDataForResult({ commit }, orderData) {
    commit('setOrderDataForResult', orderData);
  },
  clearOrderDataForResult({ commit }) {
    commit('clearOrderDataForResult');
  },
};

// mutations
const mutations = {
  setOrderDataForResult(state, orderData) {
    state.orderDataForResult = orderData;
  },
  clearOrderDataForResult(state) {
    state.orderDataForResult = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
